import { createApi } from "@reduxjs/toolkit/query/react";
import { baseQueryWithReauth } from "../setup";

export const emailApi = createApi({
  reducerPath: "emailApi",
  baseQuery: baseQueryWithReauth,
  endpoints: (builder) => ({
    sendOtpEmail: builder.mutation({
      query: ({ email }) => ({
        url: `auth/email/send-otp`,
        method: "POST",
        body: { email },
      }),
    }),
    verifyEmail: builder.mutation({
      query: ({ start_token, otp }) => ({
        url: `auth/email/verify`,
        method: "POST",
        body: { start_token, otp },
      }),
    }),
    resendEmail: builder.mutation({
      query: ({ start_token }) => ({
        url: `auth/email/resend`,
        method: "POST",
        body: { start_token },
      }),
    }),
  }),
});

export const {
  useSendOtpEmailMutation,
  useVerifyEmailMutation,
  useResendEmailMutation,
} = emailApi;
